module.exports = __webpack_public_path__ + "assets/img/card-bg-scroll.1c4085c6.png";